import React from 'react'
import { Box } from '@mui/material';
import {Mid} from '@mid/sdk'
import { Header } from '../Components/Header';

import './App.css'
import Main from "./Main";

const App: React.FC<{ mid: Mid }> = ({mid}) => {
    return (
        <Box className="Page bg-gradient" display="flex" flexDirection="column">
          <Header />
          <Main/>
        </Box>
    )
}

export default App
